import styles from './helpers.module.scss';
import { ValueFormatterParams } from 'ag-grid-community';

import { Checkbox, CheckboxLabel } from '@frontend-workspace/react-shared-lib';
import { VerifyStatusEnum } from './_enums/verify-status';
import { AccountStatusEnum } from './_enums/account-status';
import { useTranslation } from 'react-i18next';
import { IProductGroup } from './_models/product-group';

export const dateFormatter = (date: string | null | undefined | Date, type?: string) => {
  const { t } = useTranslation();
  if (!date) return t("helpers.noDate");
  const dateObject = new Date(date);
  const hours = ("0" + dateObject.getHours()).slice(-2);
  const minutes = ("0" + dateObject.getMinutes()).slice(-2);
  const seconds = ("0" + dateObject.getSeconds()).slice(-2);
  const formattedTime = hours + ':' + minutes + ':' + seconds;
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  };
  return dateObject.toLocaleDateString('nb-NO', options) + " " + formattedTime;
};

export const getPlainDate = (date: string | number | null | undefined | Date, t: any, type?: string): string => {
  if (!date) return t("helpers.noDate");
  const dateObject = new Date(date);

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };
  return dateObject.toLocaleDateString('nb-NO', options);
};

export const getPlainDateWithoutHooks = (date: Date) => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  };
  return date.toLocaleDateString('nb-NO', options);
};

export function getDateAfterMonths(months: number) {
  const today = new Date();
  return new Date(today.getFullYear(), today.getMonth() + months, today.getDate());
}

export function getTimezone(utcOffset: number) {
  const sign = utcOffset < 0 ? '-' : '+';
  return `UTC${sign}${String(Math.abs(Number(utcOffset / 60))).padStart(2, "0")}:00`;
};

export function isNumerical(value: string) {
  return /^\d*\.?\d*$/.test(value);
}

export function getInitialsFromEmail(email: string): string {
  const namePart = email.split('@')[0];

  const initials = namePart
    .split('.')
    .map(name => name.charAt(0).toUpperCase())
    .join('');

  return initials;
}

export const iconUrlCellRenderer = (props: any) => (
  <img src={props.data.iconUrl} alt="" width="30" height="30" />
);

export const formatter = (params: ValueFormatterParams) => {
  const { t } = useTranslation();
  const value: any = params.colDef.field;
  const data = params.data[value];
  if (!data) return t("helpers.valueMissing");
  const { status, oldValue, newValue } = data;
  if (data && status === VerifyStatusEnum.NEW) return newValue || null;
  if (data && status === VerifyStatusEnum.EXISTING) return oldValue || null;
  if (data && status === VerifyStatusEnum.UPDATED) return `${oldValue} => ${newValue}`;
  return t("helpers.valueMissing");
};

export const booleanFormatter = (params: ValueFormatterParams) => {
  const { t } = useTranslation();
  const value: any = params.colDef.field;
  const data = params.data[value];
  if (!data) return t("helpers.valueMissing");
  const { status, oldValue, newValue } = data;
  console.log(data, value);
  let val = false;
  if (data && status === VerifyStatusEnum.NEW) val = newValue || false;
  if (data && status === VerifyStatusEnum.EXISTING) val = oldValue || null;
  if (data && status === VerifyStatusEnum.UPDATED) val = newValue;
  return (
    <CheckboxLabel
      checked={val}
      disabled
    />
  );
};

export const booleanRenderer = (params: ValueFormatterParams) => {
  const { t } = useTranslation();
  const { status, oldValue, newValue } = params.value;
  if (params.value && status === VerifyStatusEnum.NEW) return <Checkbox value={newValue} />
  if (params.value && status === VerifyStatusEnum.EXISTING) return <Checkbox value={oldValue} />
  if (params.value && status === VerifyStatusEnum.UPDATED) return <Checkbox value={newValue} />
  return t("helpers.valueMissing");
};

export const numberToNok = (number: number, isWholeNumber?: boolean) => {
  const formatter = new Intl.NumberFormat('nb-NO', { style: 'currency', currency: 'NOK', currencyDisplay: "code", minimumFractionDigits: isWholeNumber ? 0 : 2 });
  return isWholeNumber ? `${formatter.format(number)},-` : formatter.format(number);
};

// export function minuteConverter(timeInMinutes: number, defaultMessage: string) {
//   if (!timeInMinutes) return defaultMessage;
//   const hours = timeInMinutes >= 0 ? Math.floor(timeInMinutes / 60) : Math.ceil(timeInMinutes / 60);
//   const minutes = timeInMinutes % 60;
//   const hoursText = hours !== 0 ? `timer: ${hours}` : "";
//   return `${hours}t:${minutes}m`;
// };

export const AccountStatusMessage = (status: AccountStatusEnum) => {
  const { t } = useTranslation();
  switch (status) {
    case AccountStatusEnum.NoAccountOnEmail:
      return t("helpers.noAccountOnEmail");
    case AccountStatusEnum.NoKnownIssues:
      return t("helpers.noKnownIssues");
    case AccountStatusEnum.InvitationExists:
      return t("helpers.invitationExists");
    case AccountStatusEnum.AccountRequestExists:
      return t("helpers.accountRequestExists");
    case AccountStatusEnum.UserHasNotFinishedRegistration:
      return t("helpers.userHasNotFinishedRegistration");
    case AccountStatusEnum.MissingPassword:
      return t("helpers.missingPassword");
    case AccountStatusEnum.NoAccountChosen:
      return "";
  }

};